import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=0a07b232&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=0a07b232&prod&lang=scss&scoped=true"
import style1 from "./Modal.vue?vue&type=style&index=1&id=0a07b232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a07b232",
  null
  
)

export default component.exports